import { getCookieValue } from './browser-cookie-handler.mjs';

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/**
 * Get the browser ID from the cookie
 * @param cookieName - The cookie name from global settings
 * @returns The browser ID if the cookie exists
 */
function getBrowserId(cookieName) {
    return getCookieValue(cookieName);
}

export { getBrowserId };
